import { GridColDef } from '@mui/x-data-grid';
import { useMemo } from 'react';
import {
  HandlersWorkflowTypeWithSigning as DbWorkflowType,
  useDeleteApiProgramsByIdWorkflowTypesAndTypeMutation,
  useGetApiProgramsByIdWorkflowTypesQuery,
  useGetApiWorkflowsTypesQuery,
  usePostApiProgramsByIdWorkflowTypesMutation,
} from '../../../../app/athenaApiGen';
import AdminPatternBJoinPanel from '../AdminPatternBJoinPanel';

// The GET /api/programs/{id}/workflow-types endpoint returns string[] rather
// than an object array. Adapt that to { workflowType: string }[] before passing
// into the generic Pattern B panel so we can render and key off a field name.
type ProgramWorkflowTypeRow = { workflowType: string };

const columns: GridColDef<ProgramWorkflowTypeRow>[] = [
  { field: 'workflowType', headerName: 'Workflow Type', flex: 1 },
];

const usePtwtList = (parentId: string) => {
  const result = useGetApiProgramsByIdWorkflowTypesQuery(
    { id: parentId },
    { skip: !parentId },
  );
  const data = useMemo<ProgramWorkflowTypeRow[]>(
    () => (result.data ?? []).map((wt) => ({ workflowType: wt })),
    [result.data],
  );
  return {
    ...result,
    data,
  };
};

const AdminProgramWorkflowTypesPanel = () => (
  <AdminPatternBJoinPanel<ProgramWorkflowTypeRow, DbWorkflowType>
    tableName="Program Workflow Type"
    apiPath="/api/programs/{id}/workflow-types"
    parentType="program"
    useList={usePtwtList}
    useAdd={usePostApiProgramsByIdWorkflowTypesMutation}
    useRemove={useDeleteApiProgramsByIdWorkflowTypesAndTypeMutation}
    buildAddArg={(parentId, child) => ({
      id: parentId,
      handlersProgramWorkflowTypeRequest: {
        workflowType: child.workflowType ?? '',
      },
    })}
    buildRemoveArg={(parentId, row) => ({
      id: parentId,
      type: row.workflowType,
    })}
    useChildList={() => useGetApiWorkflowsTypesQuery({ archived: false })}
    childPkAccessor="workflowType"
    childLabelAccessor="workflowType"
    joinChildIdAccessor="workflowType"
    columns={columns}
  />
);

export default AdminProgramWorkflowTypesPanel;
